import { useEffect, useState } from "react";
import { Button } from "../../../Components/Buttons";
import { ToastMessage } from "../../../Components/Utils";
import RichTextEditor from "../../../Components/RichTextEditor";
import { useFetchPageContentQuery, useSavePageContentMutation } from "../../../stores/api/page-content.api";

const PAGE_OPTIONS = [
  { value: "terms", label: "Terms & Conditions" },
  { value: "privacy", label: "Privacy Policy" },
];

const PageContentSettings = () => {
  const [page, setPage] = useState("terms");
  const [content, setContent] = useState("");

  const { data, isLoading } = useFetchPageContentQuery(page);
  const [save, { isLoading: isSaving }] = useSavePageContentMutation();

  useEffect(() => {
    setContent(data?.content ?? "");
  }, [data]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await save({ page, content }).unwrap();
      ToastMessage("success", "Page content saved successfully");
    } catch {
      ToastMessage("error", "Failed to save page content");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="flex flex-col gap-1.5">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
          Page
        </label>
        <select
          value={page}
          onChange={(e) => setPage(e.target.value)}
          className="w-full max-w-xs rounded-lg border border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-800 text-gray-900 dark:text-gray-100 px-3 py-2 text-sm outline-none focus:border-green-400 transition-colors"
        >
          {PAGE_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>

      <div className="flex flex-col gap-1.5">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
          Content
        </label>
        {isLoading ? (
          <div className="h-64 animate-pulse rounded-lg bg-gray-100 dark:bg-slate-700" />
        ) : (
          <RichTextEditor
            value={content}
            onChange={setContent}
            placeholder="Enter page content…"
            minHeight={350}
          />
        )}
      </div>

      <Button type="submit" disabled={isSaving}>
        {isSaving ? "Saving…" : "Save Content"}
      </Button>
    </form>
  );
};

export default PageContentSettings;
